import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Invoice } from '~hooks/useInvoices/models';

import { FlexColumn } from '../../styled';

interface DriverStartColumnProps {
  invoice: Invoice;
  sx?: SxProps<Theme>;
}

const DriverStartColumn = ({ invoice, sx }: DriverStartColumnProps) => {
  const { adjustedLoggingStartedAt, loggingStartedAt } = invoice.jobSummary ?? {};
  const effectiveStartTime = adjustedLoggingStartedAt ?? loggingStartedAt;

  let startTime = null;
  let startDate = null;

  if (effectiveStartTime) {
    startTime = dayjs.tz(effectiveStartTime).format('hh:mm A');
    startDate = dayjs.tz(effectiveStartTime).format('DD-MMM-YYYY');
  }

  if (!startTime && !startDate) {
    return (
      <Box sx={sx}>
        <OverflowAwareText>-</OverflowAwareText>
      </Box>
    );
  }

  return (
    <Box sx={sx}>
      {(startTime || startDate) && (
        <FlexColumn>
          {startTime && (
            <OverflowAwareText fontWeight={700}>{startTime}</OverflowAwareText>
          )}
          {startDate && <OverflowAwareText>{startDate}</OverflowAwareText>}
        </FlexColumn>
      )}
    </Box>
  );
};

export default DriverStartColumn;
